import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const Container = styled.div(({ theme }) => ({
    margin: `${theme.spacing.small} 0`,
    position: "relative",
    zIndex: 1,
    "input:hover,input:focus": {
        background: theme.colors[theme.colorMode].background_Primary,
    },
}));

export const RupeeContainer = styled(Text)({
    display: "flex",
    alignItems: "center",
    maxHeight: 56,
    position: "absolute",
    height: "100%",
    marginLeft: 10,
    zIndex: 1,
});
